import React from 'react';
import PropTypes from 'prop-types';

import Button from '@dc/ui-library/src/molecules/Button/Button';


export default function GeolocationButton(props) {

  const classes = ['dc-geolocation-button'];

  if (props.disabled) {
    classes.push('dc-geolocation-button-disabled');
  }

  return (
    <Button
      icon="Target"
      onClick={props.onClick}
      type="button"
      disabled={props.disabled}
      classes={classes.join(' ')}
    >
      {props.label}
    </Button>
  );

}


GeolocationButton.propTypes = {
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func
};

GeolocationButton.defaultProps = {
  onClick: () => {}
};
